import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[Routes]/ctabanner.js");
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[Routes]/section1.js");
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[Routes]/section2.js");
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[Routes]/slider.js");
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/componenets/Footer.js");
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/componenets/Homep.js");
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/componenets/Navbar.js");
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/componenets/Tawko.js")